<template>
    <div style="width: 156mm;border-bottom: 2pt solid black;border-top: 2pt solid black;position: absolute;bottom: 0mm;left: 0mm;"
         :style="{'font-family':printOrg.font,'font-size':printOrg.fontSize}">
        <div v-if="(toOrg.bottom&&noNull(toOrg.text))||ccOrg.enable"
             :style="{'border-bottom':printOrg.text?'0.25mm solid black':''}">
            <div v-if="toOrg.bottom&&noNull(toOrg.text)"
                 style="word-break:break-all;display: flex;flex-direction: row;justify-content: flex-start;margin-left:5.54mm;margin-right:5.54mm;">
                <div style="flex-shrink: 0;flex-grow: 0">主送：</div>
                <div>{{toOrg.text}}</div>
            </div>
            <div v-if="ccOrg.enable"
                 style="word-break:break-all;display: flex;flex-direction: row;justify-content: flex-start;margin-left:5.54mm;margin-right:5.54mm;">
                <div style="flex-shrink: 0;flex-grow: 0">抄送：</div>
                <div>{{ccOrg.text}}</div>
            </div>
        </div>
        <div v-if="noNull(printOrg.text)"
             style="word-break:break-all;display: flex;flex-direction: row;justify-content: space-between">
            <span style="margin-left:5.54mm;">{{printOrg.text}}</span>
            <span v-if="printOrg.date" v-html="convert(printOrg.date+'印发')"
                  style="margin-right:5.54mm;"></span>
        </div>

    </div>
</template>

<script>
    export default {
        name: "DocTail",
        props: {
            toOrg: {},
            printOrg: {},
            ccOrg: {}
        },
        methods: {
            noNull(content) {
                return content && content.length > 0;
            },
            convert(content, appendId) {
                return this.$tool.text2Html(content, appendId);
            }
        }
    }
</script>